var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkedAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.309,
    height: 21.608,
    viewBox: "0 0 24.309 21.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marked-alt",
    "data-name": "Icon awesome-map-marked-alt",
    d: "M12.155,0A5.318,5.318,0,0,0,6.837,5.318c0,2.374,3.475,6.7,4.807,8.273a.666.666,0,0,0,1.021,0c1.332-1.571,4.807-5.9,4.807-8.273A5.318,5.318,0,0,0,12.155,0Zm0,7.09a1.773,1.773,0,1,1,1.773-1.773A1.772,1.772,0,0,1,12.155,7.09ZM.849,9.114A1.351,1.351,0,0,0,0,10.368V20.932a.675.675,0,0,0,.926.627l5.827-2.652V9.07a12.781,12.781,0,0,1-.9-1.959Zm11.305,6.065a2.016,2.016,0,0,1-1.541-.716c-.83-.979-1.712-2.094-2.511-3.238v7.681l8.1,2.7V11.226c-.8,1.143-1.681,2.259-2.511,3.238A2.017,2.017,0,0,1,12.155,15.179ZM23.383,6.8,17.557,9.454V21.608l5.9-2.361a1.35,1.35,0,0,0,.849-1.254V7.429A.675.675,0,0,0,23.383,6.8Z",
    fill: "#337dff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkedAlt);
export default __webpack_public_path__ + "static/media/map-marked-alt.836259a70a0052fac742c4deffb65a12.svg";
export { ForwardRef as ReactComponent };